






import Vue from 'vue'
import selectMixin from './select-mixin'
import schools from '@/data/schools.json'

export default Vue.extend({
  name: 'ClassSelect',
  data () {
    return {
      schools,
    }
  },
  mixins: [selectMixin],
})
